import { EasyUpload } from './EasyUploadFile'
export type {RenderUploadUIProps,EasyUploadFileProps} from './EasyUploadFile'
export { EasyUpload } from './EasyUploadFile'
import {UploadImageTypeUI} from './RenderUploadUI'

EasyUpload.ImageTypeUI = UploadImageTypeUI